import { useQuery } from '@apollo/client'
import { useState } from 'react'

import { useWorkspaceParam } from 'features/workspace/hooks/useWorkspaceParam'
import { DEFAULT_POOLING_INTERVAL } from 'providers/graphql/constants'
import { AdUnitForTable } from '../../types'
import { adUnitForTableFromDTO, sortToDTO } from './api/mapper'
import { GET_AD_UNITS_FOR_TABLE } from './api/query'
import { AdUnitForTableDTO } from './api/types'
import { UseAdUnits, UseAdUnitsProps } from './types'

export const useAdUnits = ({ filters, first, last, sort }: UseAdUnitsProps): UseAdUnits => {
  const { workspaceId } = useWorkspaceParam()
  const [adUnits, setAdUnits] = useState<AdUnitForTable[]>([])
  const [count, setCount] = useState<number>(0)

  const { loading } = useQuery(GET_AD_UNITS_FOR_TABLE, {
    onCompleted: ({ adUnits: { nodes: adUnits, totalCount: count } }): void => {
      if (adUnits) {
        setAdUnits(
          adUnits.map((node: AdUnitForTableDTO): AdUnitForTable => adUnitForTableFromDTO(node)),
        )
        setCount(count)
      }
    },
    pollInterval: DEFAULT_POOLING_INTERVAL,
    variables: {
      first,
      last,
      sort: sortToDTO(sort),
      terms: filters,
      workspaceId,
    },
  })

  return {
    adUnits,
    count,
    loading,
    setAdUnits,
  }
}
